import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';

import { media } from 'legacyComponents/styled/styleUtils';

import { Field } from 'libs/forms/views/field';
import { Validation } from 'libs/forms/views/validation';
import { InputWrapper } from 'libs/forms/styles';
import { StringFieldStore } from 'libs/forms/fieldStores';

import i18next from 'i18next';

const TextArea = styled(Textarea)`
  width: calc(100% - 20px);
  color: ${props => props.theme.color.wfGrey900};
  line-height: 1.6;
  border: 1px solid
    ${props =>
      props.focussed ? props.theme.color.grey : props.theme.color.wfGrey200};
  padding: 10px 10px;
  min-height: 80px;
  resize: none;
  cursor: ${props => (props.posting ? 'progress !important' : 'inherit')};
  background-color: transparent;
  ${media.xs`
    font-size: 16px;
    padding: 8px 10px;
  `};
`;

const TextAreaWrapper = styled(InputWrapper)`
  min-height: 80px;
  height: initial;
  padding: 0;
  position: relative;
`;

@observer
export class TextAreaField extends Field {
  static defaultStore = StringFieldStore;
  render() {
    const { fieldStore, editComponent, noValidation, responsive } = this.props;
    const Tag = editComponent || TextAreaWrapper;
    return (
      <Tag focussed={fieldStore.isFocussed} responsive={responsive}>
        <TextArea
          autoFocus={fieldStore.autoFocus}
          id={this.inputId}
          className='inputNoBorder'
          value={fieldStore.value}
          placeholder={
            fieldStore.conf.placeholder &&
            i18next.t(fieldStore.conf.placeholder)
          }
          onBlur={this.onBlur}
          onChange={this.updateValue}
          onFocus={this.onFocus}
          posting={
            fieldStore.formStore.posting
              ? `${fieldStore.formStore.posting}`
              : undefined
          }
        />
        {noValidation ? (
          ''
        ) : (
          <Validation
            fieldStore={fieldStore}
            handleClick={this.focusAfterDelete}
          />
        )}
      </Tag>
    );
  }
}
